import type { RichLead } from '../../lead.popup/types';
import type { UnitInterestedLead } from '../../services/api';
import type { AdditionalContact, Lead, RootScope } from '../../types';

import React from 'react';
import { Trans } from '@lingui/macro';

import { isValidUrl, tel } from '../../est/filters';
import { redirectToLeadReact } from '../../lead.popup/redirectToLeadReact';
import { getService } from '../../shell';
import { Button } from '../../ui';
import { useCurrentLead } from './ApplyLeadButton';

export type UnitLeadDetailsProps = {
  lead: Lead | RichLead | UnitInterestedLead | AdditionalContact;
  allowAddToClipboard?: boolean;
  isAdditionalContact?: boolean;
};

export function UnitLeadDetails({
  lead,
  allowAddToClipboard,
  isAdditionalContact,
}: UnitLeadDetailsProps) {
  const $rootScope = getService<RootScope>('$rootScope');

  const lsLead = useCurrentLead();

  if ($rootScope.embeddedIntegrationName) {
    if (isAdditionalContact || !('id' in lead)) {
      return null;
    }

    return (
      <div>
        <div className="g-overflow-fix">
          <div className="b-contacts__content p-t">
            <a
              className="b-link -type_underlined g-truncate g-text-bold"
              onClick={(event) => {
                event.preventDefault();

                $rootScope.openPathInIntergation('deal', lead.id);
              }}
            >
              <i className="material-icons md-18 m-r-sm">view_kanban</i>
              <Trans id="unit.popup.unitdeallead.integration.deal">deal</Trans>
            </a>
            <a
              className="b-link -type_underlined g-truncate g-text-bold m-l-md"
              onClick={(event) => {
                event.preventDefault();

                $rootScope.openPathInIntergation('contact', lead.id);
              }}
            >
              <i className="material-icons md-18 m-r-sm">account_circle</i>
              <Trans id="unit.popup.unitdeallead.integration.contact">
                contact
              </Trans>
            </a>
            <a
              className="b-link -type_underlined g-truncate g-text-bold m-l-md"
              onClick={(event) => {
                event.preventDefault();

                redirectToLeadReact(lead.id);
              }}
            >
              <i className="material-icons md-18 m-r-sm">chrome_reader_mode</i>
              <Trans id="unit.popup.unitdeallead.integration.units">
                units
              </Trans>
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      {!!(lead.phone || lead.email || allowAddToClipboard) && (
        <div className="g-overflow-fix">
          <div className="b-contacts__content">
            {allowAddToClipboard && !isAdditionalContact && 'id' in lead && (
              <Button
                className="m-b"
                block
                disabled={lsLead?.id === lead.id}
                onClick={() => {
                  $rootScope.copyLeadToClipboard(lead, true);
                }}
              >
                <Trans id="unit.popup.tooltip.clipboard">
                  Add lead to clipboard
                </Trans>
              </Button>
            )}

            {!!lead.phone && <div className="m-b-sm">{tel(lead.phone)}</div>}

            {!!lead.email && <div className="m-b-sm">{lead.email}</div>}

            {lead.contacts?.map((contact) => (
              <div key={contact.value} className="m-b-sm">
                {isValidUrl(contact.value) ? (
                  <div className="g-truncate">
                    <a
                      className="b-link -type_underlined"
                      target="_blank"
                      rel="noreferrer"
                      href={contact.value}
                    >
                      {contact.value}
                    </a>
                  </div>
                ) : (
                  <div>{tel(contact.value)}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
